/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ScholarshipTypeGridItemViewModel } from "../types/ScholarshipTypeGridItemViewModel.ts";
import { scholarshipTypeFileViewModelSchema } from "./scholarshipTypeFileViewModelSchema.ts";

export const scholarshipTypeGridItemViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do tipo de bolsa.")),
  companyId: z
    .number()
    .int()
    .describe("ID da empresa associada. Opcional.")
    .nullish(),
  companyDescription: z
    .string()
    .describe("Nome da empresa associada (vazio quando não há).")
    .nullish(),
  description: z.string().describe("Descrição do tipo de bolsa.").nullish(),
  instruction: z
    .string()
    .describe("Instruções da bolsa para o aluno. Opcional.")
    .nullish(),
  hasFixedValue: z.optional(
    z
      .boolean()
      .describe("Indica se a bolsa possui percentual fixo de desconto."),
  ),
  percentage: z
    .number()
    .describe("Percentual de desconto. Valor entre 0 e 100. Opcional.")
    .nullish(),
  exemptRegistrationValue: z.optional(
    z.boolean().describe("Indica se a bolsa isenta a taxa de inscrição."),
  ),
  registrationDate: z
    .string()
    .datetime()
    .describe("Data de cadastro do tipo de bolsa. Opcional.")
    .nullish(),
  files: z
    .array(z.lazy(() => scholarshipTypeFileViewModelSchema))
    .describe("Documentos (arquivos-modelo) do tipo de bolsa.")
    .nullish(),
}) as unknown as ToZod<ScholarshipTypeGridItemViewModel>;
